export const API_URL = process.env.REACT_APP_API_HOST || '';
export const USER_ID = 1;
export const AUTH_TOKEN = 'auth_token';
